import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Button,
    IconButton,
    Chip,
    TextField,
    Stack,
    Modal,
} from "@mui/material";
import { ExpandMore, Check, Delete } from "@mui/icons-material";
import { ImagePaths } from "../../Utility/ImagePaths";
import { useHistory } from 'react-router-dom'
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ToastMsg from "../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../Utility/API/Serviceurls";
import { useLocation } from 'react-router-dom'
import { formatDate } from "../../Components/CommonFunctions/CommonFunctions";
import { ToolsFieldWithMic } from "../../Components/Common Components/CommonComponents";
import { DateTime } from "luxon";
import { Colors } from "../../Styles/Colors";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

const RtTherapySessions = (props) => {
    const history = useHistory();
    const location = useLocation();
    const [sessionDetails, setSessionDetails] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [sessionNotes, setSessionNotes] = useState("");
    const [viewSessionNotes, setviewSessionNotes] = useState("");

    const [Attachment, setAttachment] = useState(
        {
            open: false,
            imageuploadList: [],
            imageViewerPopup: false,
            viewData: [],
            viewImage: null,
            selectedImage: null,
            imgCapClked: false,
            CapturedImg: null,
            currentIndex: 0,
        }
    );


    const setEditedData = (data) => {
        setSessionNotes(data);
    };

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
        setisloader(false)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
        setisloader(false)
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    useEffect(() => {
        GetTherapySessionDatas();
    }, [])

    const GetTherapySessionDatas = () => {
        RestAPIService.getAll(Serviceurls.RT_THERAPIST_SESSIONS + `?patient_radiotherapy_id=${location.states?.TherapyDetailId}&date=${DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    setSessionDetails(response.data.data || []);
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const postSessionUpdate = (row, forComplete = false) => {
        try {
            let startDate = new Date()
            let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
            let Aptime = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_SIMPLE);
            const session_date = date ? `${DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")} ${Aptime}:00` : ""
            let data = {
                'session_id': row?.id,
                'start_time': session_date,
            }
            if (forComplete) {
                data['therapist_notes'] = sessionNotes
            }
            setisloader(true)
            RestAPIService.updateWithOutId(data, Serviceurls.RT_THERAPIST_UPDATE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        GetTherapySessionDatas()
                        setSessionNotes("")
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getS3Key = async (doc_key, id) => {
        try {
            const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));

            if (response.data.status === "success") {
                const Data = response.data;
                return {
                    data_url: Data.data
                };
            }
        } catch (e) {
            setisloader(false)
            errorMessage("Error fetching S3 URL")
        }
    }

    const renderImage = async (imageData, pdfData) => {
        let tempArr = [];

        if (imageData.length > 0) {
            for (let i = 0; i < imageData.length; i++) {
                let image = imageData[i]?.doc_key;
                if (image !== null) {
                    let doc_key = image;
                    let getData = await getS3Key(doc_key); // make sure this is a top-level async function
                    getData["type"] = image.split('.').pop() === "pdf" ? "pdf" : "image";
                    tempArr.push(getData);
                }
            }
        }

        setAttachment(prev => {
            const updated = {
                ...prev,
                viewData: tempArr,
                viewImage: tempArr[0]
            };

            // Do window.open *after* state is set
            if (pdfData) {
                setTimeout(() => {
                    if (updated.viewImage?.data_url) {
                        window.open(updated.viewImage.data_url);
                    }
                }, 0);
            }

            return updated;
        });
    };

    const prevImage = (index) => {
        let currentIndex = parseInt(index) || 0;

        if (currentIndex >= 1) {
            setAttachment((prev) => ({
                ...prev,
                currentIndex: currentIndex - 1,
                viewImage: prev.viewData[currentIndex - 1],
            }));
        }
    };

    const nextImage = (index) => {
        let currentIndex = parseInt(index) || 0;

        if (currentIndex + 1 < Attachment.viewData.length) {
            setAttachment((prev) => ({
                ...prev,
                currentIndex: currentIndex + 1,
                viewImage: prev.viewData[currentIndex + 1],
            }));
        }
    };


    const renderImageViewerPopup = () => {
        try {
            if (Attachment.viewData?.length > 0) {
                return (
                    <Box component={'div'}>
                        <Modal open={Attachment.imageViewerPopup}>
                            <Box className='eMed_Doc_Img_Pop_Up'>
                                <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'1vw'} alignItems={'center'} justifyContent={'space-between'}>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                                        Added Documents
                                    </Typography>
                                    <Button
                                        onClick={() =>
                                            setAttachment((prev) => ({
                                                ...prev,
                                                imageViewerPopup: false,
                                            }))
                                        }
                                    >
                                        <Box
                                            component={'img'}
                                            src={ImagePaths.LabCloseButton.default}
                                            height={'1vw'}
                                            width={'1vw'}
                                            mr={'1vw'}
                                        />
                                    </Button>
                                </Box>

                                <Box height={'30vw'} display={'flex'} justifyContent={'center'}>
                                    {Attachment.viewData?.length > 1 && (
                                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                                            <Button
                                                size="small"
                                                className="Common_Btn_Min_Width"
                                                sx={{ height: '3vw' }}
                                                onClick={() => prevImage(Attachment.currentIndex)}
                                            >
                                                <KeyboardDoubleArrowLeftIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" />
                                            </Button>
                                        </Box>
                                    )}

                                    {Attachment.viewImage?.type === 'pdf' ? (
                                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: "3vw" }}>
                                            <img
                                                style={{ width: '12vw', height: '12vw' }}
                                                src={ImagePaths.DocumentPreview.default}
                                                alt="slide"
                                            />
                                            <Button variant="contained" onClick={() => window.open(Attachment.viewImage?.data_url)}>
                                                Download Document
                                            </Button>
                                        </Box>
                                    ) : (
                                        <Box component={'div'} height={'30vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                            <img
                                                src={Attachment.viewImage?.data_url || ''}
                                                alt="slide"
                                                style={{ objectFit: 'contain', height: '15vw', width: '30vw' }}
                                            />
                                        </Box>
                                    )}

                                    {Attachment.viewData?.length > 1 && (
                                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                                            <Button
                                                size="small"
                                                className="Common_Btn_Min_Width"
                                                sx={{ height: '3vw' }}
                                                onClick={() => nextImage(Attachment.currentIndex)}
                                            >
                                                <KeyboardDoubleArrowRightIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" />
                                            </Button>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Modal>
                    </Box>
                );
            }
            return null;
        } catch (error) {
            errorMessage(error?.message)
        }
    };

    return (
        <Box sx={{ padding: "0.3vw" }}>
            <Stack direction="row" spacing={1} alignItems="center">
                <IconButton size="small" onClick={() => {
                    history.push({ pathname: '/RadiotherapyTherapist' })
                }} >
                    <img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton.default} alt={"Back"} />
                </IconButton>
                <Typography sx={{ color: "#616161" }}> {"Back to Therapist Home"}</Typography></Stack>
            <Box sx={{ height: "80dvh", overflow: "auto" }}>
                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography sx={{ fontWeight: "bold" }}>Dosimetrist</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {/* Info Section */}
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "0.5vw",
                                marginBottom: "1vw",
                            }}
                        >
                            {[
                                ["TREATMENT REGION", (sessionDetails?.region_name || "-")],
                                ["TOTAL DOSE", (sessionDetails?.total_dose || "-")],
                                ["NO OF FRACTION", (sessionDetails?.number_of_fractions || "-")],
                                ["DOSE PER FRACTION", (sessionDetails?.dose_per_fraction || "-")],
                                // ["TREATMENT INTERVAL", (sessionDetails?.region_name || "-")],
                                // ["TREATMENT DURATION", (sessionDetails?.region_name || "-")],
                                ["FIELD NAME", (sessionDetails?.field_name || "-")],
                                ["FILED SIZE", (sessionDetails?.field_size || "-")],
                                ["RADIATION TECHNIQUE", (sessionDetails?.technic_name || "-")],
                                ["DEPTH", (sessionDetails?.depth || "-")],
                                ["PATIENT POSITION", (sessionDetails?.patient_position || "-")],
                                ["MACHINE", (sessionDetails?.stimulator_name || "-")],
                            ].map(([label, value], i) => (
                                <Box key={i}>
                                    <Typography sx={{ fontSize: "0.8rem", color: "gray" }}>
                                        {label}
                                    </Typography>
                                    <Typography sx={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                                        {value}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>

                        {/* Notes */}
                        <Typography sx={{ fontWeight: "bold", marginTop: "1vw" }}>
                            Dosimetrist Notes
                        </Typography>
                        <Typography sx={{ fontSize: "0.9rem", marginBottom: "1vw" }}>
                            {sessionDetails?.dosimetrist_notes || "-"}
                        </Typography>

                        {/* Attachments */}
                        <Box sx={{ display: "flex", gap: "1vw", marginTop: "0.5vw" }}>
                            {sessionDetails?.dosimetrist_documents?.length ?
                                <Button
                                    sx={{ marginTop: "0.5vw", textTransform: "capitalize" }}
                                    variant="contained"
                                    size="small"
                                    onClick={() => {
                                        if (sessionDetails?.dosimetrist_documents?.length > 0) {
                                            const imageFile = sessionDetails?.dosimetrist_documents || [];
                                            setAttachment(prev => ({
                                                ...prev,
                                                imageViewerPopup: true,
                                                viewOpen: true,
                                                viewData: [],
                                                viewImage: null
                                            }));

                                            renderImage(imageFile);
                                        } else {
                                            errorMessage('No Attachments to be view');
                                        }
                                    }}>{`Show Added Attachments (${sessionDetails?.dosimetrist_documents?.length})`}</Button> : null}
                        </Box>
                    </AccordionDetails>
                </Accordion>

                {/* Treatment Details */}
                <Box sx={{ marginTop: "2vw" }}>
                    <Typography
                        sx={{
                            fontWeight: "bold",
                            marginBottom: "1vw",
                            fontSize: "1.1rem",
                        }}
                    >
                        Treatment Details
                    </Typography>
                    <Table
                        size="small"
                        sx={{
                            border: "1px solid #ddd",
                            "& th": { background: "#f9f9f9" },
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                {[
                                    "Date of Treatment",
                                    "Treatment Site",
                                    "Technique",
                                    "Machine",
                                    "Dose Info",
                                    "Status",
                                    "Action"
                                ].map((h, i) => (
                                    <TableCell key={i} sx={{ fontWeight: "bold" }}>
                                        {h}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sessionDetails?.session_details?.length && sessionDetails?.session_details.map((row, i) => (
                                <TableRow sx={{ backgroundColor: row?.is_current ? "#dbf4f1" : null }} key={i}>
                                    <TableCell>{formatDate(row.session_date)}</TableCell>
                                    <TableCell>{sessionDetails.region_name || "-"}</TableCell>
                                    <TableCell>{sessionDetails.technic_name || "-"}</TableCell>
                                    <TableCell>{sessionDetails.stimulator_name || "-"}</TableCell>
                                    <TableCell>{row.dose_per_fraction ? `${row.dose_per_fraction} Gy` : "-"}</TableCell>
                                    <TableCell>{row.session_status}</TableCell>
                                    <TableCell>
                                        <Box>
                                            <IconButton disabled={row?.start_time || !row?.is_current || !props?.Access?.editAccess} onClick={() => { postSessionUpdate(row) }}><PlayCircleIcon color={(row?.start_time || !row?.is_current || !props?.Access?.editAccess) ? "disabled" : "primary"} /></IconButton>
                                            <IconButton
                                                disabled={!row?.start_time || row?.completed_time || !row?.is_current || !props?.Access?.editAccess}
                                                onClick={() => {
                                                    if (sessionNotes) {
                                                        postSessionUpdate(row, true)
                                                    } else {
                                                        errorMessage("Enter Current session notes to complete")
                                                    }
                                                }}><CheckCircleIcon color={(!row?.start_time || row?.completed_time || !row?.is_current || !props?.Access?.editAccess) ? "disabled" : "primary"} /></IconButton>
                                            {row?.session_notes ? <Button size="small" sx={{ textTransform: "capitalize" }} onClick={() => { setviewSessionNotes(row?.session_notes) }}>View Notes</Button> : null}
                                            {(row?.is_current && !row?.session_notes && viewSessionNotes) ? <Button size="small" sx={{ textTransform: "capitalize" }} onClick={() => { setviewSessionNotes("") }}>Add Notes</Button> : null}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>

                <Box sx={{ marginTop: "1vw" }}>
                    <TextField
                        sx={{ width: "100%", marginTop: "0.5dvw" }}
                        rows={2}
                        InputProps={{ readOnly: viewSessionNotes }}
                        label={"Session Notes"}
                        value={(viewSessionNotes ? viewSessionNotes : sessionNotes) || ""}
                        inputProps={{ maxLength: 300 }}
                        onChange={(e) => { setSessionNotes(e.target.value) }}
                        multiline />
                </Box>
            </Box>
            {renderImageViewerPopup()}
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
};

export default RtTherapySessions;
